import { useEffect } from "react";
import styles from "./requestDetails.module.css";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Snackbar,
  IconButton,
  Slide,
  DialogActions,
  TextField,
} from "@mui/material";
import { Camera, Edit, Trash2, UploadCloud, X, XCircle } from "react-feather";

import Axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

function RequestResolution({
  isPanelOpen,
  onToggle,
  updateMaintenanceDetails,
  maintenanceDetails,
  setLoading,
}) {
  const [resolutionText, setResolutionText] = useState("");
  const [isUpdateButtonVisible, setIsUpdateButtonVisible] = useState(false);
  const { getAccessTokenSilently, user } = useAuth0();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [selectedFileId, setSelectedFileId] = useState("");

  useEffect(() => {
    if (!resolutionText) {
      setResolutionText(maintenanceDetails?.resolution || "");
    }
  }, [maintenanceDetails]);

  const handleSave = async () => {
    if (!resolutionText) {
      setSnackbarOpen(true);
      setSnackbarMsg("Please enter a resolution description!");
      return;
    }
    setLoading(true);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    const requestId = maintenanceDetails.id;
    const formData = new FormData();
    formData.append("resolution", resolutionText);

    Axios.post(
      process.env.REACT_APP_CASE_API_URL +
        "v1/technician/maintenance-requests-resolve/" +
        requestId,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMsg("Resolution updated successfully!");
        setIsUpdateButtonVisible(false);
        updateMaintenanceDetails();
      })
      .catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMsg(error?.response?.data?.message);
      });
  };

  const handleFileUpload = async (file) => {
    if (!file) {
      setSnackbarOpen(true);
      setSnackbarMsg("Please select a valid file!");
    }

    if (file.size > 10 * 1024 * 1024) {
      setSnackbarOpen(true);
      setSnackbarMsg("File size must be less than 10 MB!");
      return;
    }

    setLoading(true);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    const requestId = maintenanceDetails.id;
    const formData = new FormData();
    formData.append("image", file);
    // const payload = {images: file}

    Axios.post(
      process.env.REACT_APP_CASE_API_URL +
        `v1/technician/maintenance-requests/${requestId}/resolve-upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMsg("File uploaded successfully!");

        updateMaintenanceDetails();
      })
      .catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMsg(error?.response?.data?.message);
      });
  };

  const onDeleteFile = async (file) => {
    setDeleteModalOpen(false);
    if (!selectedFileId) {
      return;
    }

    setLoading(true);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    const fileId = selectedFileId;

    Axios.delete(
      process.env.REACT_APP_CASE_API_URL +
        `v1/technician/maintenance-requests/files/${fileId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMsg("File deleted successfully!");
        updateMaintenanceDetails();
      })
      .catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMsg(error?.response?.data?.message);
      });
  };

  return (
    <div className={`${styles.AccordionList}`}>
      <div
        className={`${styles.AccordionListHead} ${
          isPanelOpen ? styles.Open : ""
        }`}
        onClick={onToggle}
      >
        <p className={`${styles.Title}`}>Resolution</p>
        <img src="/static/img/downTriangle.svg" />
      </div>
      <div
        className={`${styles.AccordionListBody} ${
          isPanelOpen ? styles.Open : ""
        }`}
      >
        <div className={`${styles.AccouFormGroup}`}>
          <div className={`${styles.ReqAddRow}`}>
            <div className={`${styles.ReqAddFormSec}`}>
              <div className={`${styles.FormSec}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <TextField
                    value={resolutionText}
                    id="outlined-multiline-static"
                    label="Add Description*"
                    multiline
                    rows={6}
                    onChange={(e) => {
                      setResolutionText(e.target.value);
                      if (!isUpdateButtonVisible) {
                        setIsUpdateButtonVisible(true);
                      }
                    }}
                  />
                </div>
              </div>
              <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                <div className={`${styles.FileIMGDiv}`}>
                  <div className={`${styles.FileUpDuBUDiv}`}>
                    <label
                      for="file-upload"
                      className={`${styles.UploadLabel}`}
                    >
                      <UploadCloud />
                      <p>Upload Documents/Photos</p>
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx"
                      onChange={(e) => {
                        if (e.target.files[0]) {
                          handleFileUpload(e.target.files[0]); // call upload immediately
                        }
                      }}
                    />
                    <p className={`${styles.UploadText}`}>
                      File size upto 10 MB. 
                      JPG, PNG, PDF, DOC, XLS file only
                    </p>
                  </div>

                  <div className={`${styles.UpIMGSec}`}>
                    {maintenanceDetails?.resolve_images?.map((file) => {
                      const isImage = /\.(jpg|jpeg|png)$/i.test(file.file_path);
                      const isPDF = /\.pdf$/i.test(file.file_path);
                      const isDoc = /\.(doc|docx)$/i.test(file.file_path);
                      const isExcel = /\.(xls|xlsx)$/i.test(file.file_path);

                      return (
                        <div key={file.id} className={styles.ImgFile}>
                          <Button
                            onClick={() => {
                              setSelectedFileId(file.id);
                              setDeleteModalOpen(true);
                            }}
                          >
                            {" "}
                            <X />
                          </Button>

                          {isImage && (
                            <img
                              src={file.file_public_url}
                              alt="Uploaded file"
                              className={styles.UpIMG}
                            />
                          )}

                          {isPDF && (
                            <a
                              href={file.file_public_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.FileLink}
                            >
                              <img src="/static/img/pdfIcon.png" />
                              <p className={`${styles.FilePathName}`}>{file?.file_path}</p>
                            </a>
                          )}

                          {isDoc && (
                            <a
                              href={file.file_public_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.FileLink}
                            >
                              <img src="/static/img/docIcon.png" />
                              <p className={`${styles.FilePathName}`}>{file?.file_path}</p>
                            </a>
                          )}

                          {isExcel && (
                            <a
                              href={file.file_public_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.FileLink}
                            >
                              <img src="/static/img/excelIcon.png" />
                              <p className={`${styles.FilePathName}`}>{file?.file_path}</p>
                            </a>
                          )}
                        </div>
                      );
                    })}

                    {maintenanceDetails?.resolve_images?.length === 0 && (
                      <div className={`${styles.NoImgDiv}`}>
                        <img src="/static/img/no-photo.png" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isUpdateButtonVisible && (
            <div className={`${styles.ButtonAction}`}>
              <button onClick={handleSave} className={`${styles.ResEditBU}`}>
                {maintenanceDetails?.resolution ? "Update" : "Save"}
              </button>
            </div>
          )}
        </div>

        {/* <p className={`${styles.SummaryDetails}`}>
          <input
            value={resolutionText}
            onChange={(e) => {
              setResolutionText(e.target.value);
              if (!isUpdateButtonVisible) {
                setIsUpdateButtonVisible(true);
              }
            }}
          />
        </p>
        {isUpdateButtonVisible && (
          <button onClick={handleSave}>
            {maintenanceDetails?.resolution ? "Update" : "Save"}
          </button>
        )} */}

        {/* //upload image section */}
        {/* <div className={`${styles.ReqDeAddBodyFile}`}>
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx"
            onChange={(e) => {
              if (e.target.files[0]) {
                handleFileUpload(e.target.files[0]); // call upload immediately
              }
            }}
          />
        </div> */}

        {/* <div className={`${styles.ReqDeAddBodyFile}`}>
          <p className={`${styles.FileTitle}`}>Images</p>
          {maintenanceDetails?.resolve_images?.map((file) => {
            const isImage = /\.(jpg|jpeg|png)$/i.test(file.file_path);
            const isPDF = /\.pdf$/i.test(file.file_path);
            const isDoc = /\.(doc|docx)$/i.test(file.file_path);
            const isExcel = /\.(xls|xlsx)$/i.test(file.file_path);

            return (
              <div key={file.id} className={styles.AddFormFileUP}>
                <XCircle
                  onClick={() => {
                    setSelectedFileId(file.id);
                    setDeleteModalOpen(true);
                  }}
                />

                {isImage && (
                  <img
                    src={file.file_public_url}
                    alt="Uploaded file"
                    className={styles.UpIMG}
                  />
                )}

                {isPDF && (
                  <a
                    href={file.file_public_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.FileLink}
                  >
                    📄 View PDF
                  </a>
                )}

                {isDoc && (
                  <a
                    href={file.file_public_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.FileLink}
                  >
                    📝 View Document
                  </a>
                )}

                {isExcel && (
                  <a
                    href={file.file_public_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.FileLink}
                  >
                    📊 View Excel
                  </a>
                )}
              </div>
            );
          })}

          {maintenanceDetails?.resolve_images?.length === 0 && (
            <div className={`${styles.NoImgDiv}`}>
              <img src="/static/img/no-photo.png" />
            </div>
          )}

          <div className={`${styles.NoImgDiv}`}>
                              <img src="/static/img/no-photo.png" />
                            </div>
        </div> */}
      </div>

      <Dialog
        open={deleteModalOpen}
        onClose={(e) => setDeleteModalOpen(false)}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete the file?
          <button onClick={(e) => setDeleteModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <div className="ModalFormGroup">
            <label className="PopupBodyText">
              The file will be removed immediately.You can't undo this action.
            </label>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => onDeleteFile()} className="CancelPopupBU">
            Delete
          </Button>
          <Button
            onClick={(e) => setDeleteModalOpen(false)}
            className="SubmitPopupBU"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        onClose={(e) => setSnackbarOpen(false)}
        TransitionComponent={Slide}
        message={snackbarMsg}
        autoHideDuration={10000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(e) => setSnackbarOpen(false)}
          >
            <X />
          </IconButton>
        }
      />
    </div>
  );
}

export default RequestResolution;
